import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { userInfoUnlinkedBusinessAccountsCacheKey } from "./constants";
import type { UserInfoUnlinkedBusinessAccountsApiProps, UserInfoUnlinkedBusinessAccountsResponse } from "./types";

export const getUserInfoUnlinkedBusinessAccountsByIdentifier = reactQueryFetcherAdapter(
  userInfoUnlinkedBusinessAccountsCacheKey,
  (
    signal,
    { userIdentifier, searchQuery }: UserInfoUnlinkedBusinessAccountsApiProps
  ): Promise<UserInfoUnlinkedBusinessAccountsResponse> => {
    return fetch<UserInfoUnlinkedBusinessAccountsResponse>(
      `/apps/user_info_unlinked_business_accounts/${encodeURIComponent(userIdentifier)}`,
      "GET",
      { search_query: searchQuery },
      { signal }
    );
  }
);
